import Dropdown from "~/common/ui/Dropdown";
import Link from "next/link";
import { HiOutlineTrash, HiOutlineCurrencyDollar } from "react-icons/hi";

const CAR_STATUS = {
  ACTIVO: 1,
  ELIMINADO: 2,
  PUBLICADO: 3,
  VENDIDO: 4,
  PAUSADO: 5,
};

const EditButton = ({ carId }) => {
  return (
    <Link href={`/admin/inventario/${carId}`}>
      <a className="rounded-l-md  py-1 px-1 text-xs md:text-sm text-gray-600 hover:bg-gray-50 hover:text-gray-700">
        Editar
      </a>
    </Link>
  );
};

export default function ActionDropdown({ carId, statusId, onClick }) {
  return (
    <Dropdown.WithButton button={<EditButton carId={carId} />}>
      {statusId === CAR_STATUS.PUBLICADO && (
        <div className="p-1">
          <Dropdown.Item
            text="Vender"
            onClick={() => onClick({ name: "Vender" })}
            Icon={HiOutlineCurrencyDollar}
          />
        </div>
      )}
      <div className="p-1">
        <Dropdown.Item
          text="Eliminar"
          onClick={() => onClick({ name: "Eliminar" })}
          Icon={HiOutlineTrash}
        />
      </div>
    </Dropdown.WithButton>
  );
}
